import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AppRoutes from '@ui/containers/layout/AppRoutes';
import { useEffect } from 'react';
import moment from 'moment';
import i18n from './i18n';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { logout } from '@application/features/auth/authSlice';
import { resetStateByPathName } from '@application/common/helpers/state-helper';
import { Loader } from '@ui/components/common/Loader';
import { SuccessSparkLayer } from '@ui/components/common/micro-interactions';
import { Box } from '@mui/material';
import { palette } from './theme/palette';
const theme = palette('light');
function App() {
    const { isLoading } = useAppSelector((state) => state.loading);
    const { currentUser } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const location = useLocation();
    useEffect(() => {
        if (currentUser) {
            if (currentUser.role === 'Freelancer') {
            }
        }
    }, [currentUser, dispatch]);
    useEffect(() => {
        moment.locale(i18n.language);
    }, []);
    useEffect(() => {
        const onStorageChange = (event) => {
            if (event.key === 'AUTH_TOKEN' && event.newValue === null)
                dispatch(logout());
        };
        window.addEventListener('storage', onStorageChange);
        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, [dispatch]);
    useEffect(() => {
        return () => {
            resetStateByPathName(location.pathname);
        };
    }, [location.pathname]);
    return (_jsxs(Box, { sx: { background: theme.background.neutral }, children: [_jsx(ToastContainer, { position: 'top-right', autoClose: 2000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: 'colored' }), isLoading && _jsx(Loader, { isLoading: isLoading }), _jsx(SuccessSparkLayer, {}), _jsx("div", { className: '', children: _jsx(AppRoutes, {}) })] }));
}
export default App;
